import SearchWithoutResult from '../assets/search_without_result.png';
import { Article } from '@atreus/data';
import { Box, Container, Image, Text } from '@qcx/ui';
import { PostSection } from './post/PostSection';

interface SearchNoResultsProps {
  searchTerm: string;
  subject: string;
  otherArticles?: Article[];
}

export const SearchNoResults = ({
  searchTerm,
  otherArticles,
  subject
}: SearchNoResultsProps) => (
  <Box
    css={{
      flexColCenter: true
    }}
  >
    <Container
      css={{
        border: '1px solid $separatorColor',
        rounded: '$4xl',
        minH: 342,
        d: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center ',
        '@lg': {
          w: '$3of4'
        }
      }}
    >
      <Box>
        <Image
          css={{
            w: 152
          }}
          width={152}
          height={118}
          alt="Logo"
          src={SearchWithoutResult}
          noAspectRatio
          priority
        />
      </Box>
      <Text as="h4" variant="lg" weight="medium">
        Nenhuma {subject} encontrada
      </Text>
      <Box
        css={{
          maxW: 342
        }}
      >
        <Text
          as="h4"
          css={{
            textAlign: 'center',
            color: '$neutral500'
          }}
          variant="sm"
        >
          Sua pesquisa <Text weight="semibold">“{searchTerm}”</Text> não
          corresponde a nenhuma das nossas {subject}s. Tente refazer a pesquisa
          com termos diferentes.
        </Text>
      </Box>
    </Container>
    {otherArticles && (
      <Box
        css={{
          mt: '$8'
        }}
      >
        <PostSection
          flow={{
            '@initial': 'column',
            '@xl': 'row'
          }}
          gap="$6"
          postCardProps={{
            flow: {
              '@xs': 'column',
              '@sm': 'row',
              '@xl': 'column'
            },
            priority: false,
            elevated: false
          }}
          posts={otherArticles}
          title="Outras notícias"
        />
      </Box>
    )}
  </Box>
);
